import { ReactNode } from 'react';
import { Box, Col, Color, Grid, GridVariant, Heading1 } from '@gousto-internal/citrus-react';

export function HeroContent({ heading, children }: { heading: string; children: ReactNode }) {
  return (
    <>
      <Box
        bg={Color.ColdGrey_800}
        paddingV={[6, 12]}
        style={{
          backgroundImage: 'url(/assets/heroMessage.svg)',
          backgroundSize: 'cover',
          backgroundPosition: '50%',
        }}
      >
        <Grid variant={GridVariant.Layout}>
          <Col size={12}>
            <Heading1 color={Color.White}>{heading}</Heading1>
          </Col>
        </Grid>
      </Box>
      <Grid variant={GridVariant.Layout} paddingV={[4, 12]}>
        <Col size={12}>{children}</Col>
      </Grid>
    </>
  );
}
